/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_OpenInputs */

const en_road_dude_prompt_open = /** @type {(inputs: Road_Dude_Prompt_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open video generator`)
};

const zh_road_dude_prompt_open = /** @type {(inputs: Road_Dude_Prompt_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开视频生成器`)
};

/**
* | output |
* | --- |
* | "Open video generator" |
*
* @param {Road_Dude_Prompt_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_open = /** @type {((inputs?: Road_Dude_Prompt_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_open(inputs)
	return zh_road_dude_prompt_open(inputs)
});
export { road_dude_prompt_open as "road_dude.prompt.open" }